export const binStatus = {
  'DTMD': 'Determined',
  'URVW': 'Under Review',
  'RECV': 'Received',
  'RQD': 'Required',
  '': ''
};